import { render, staticRenderFns } from "./PricingRuleGroup.vue?vue&type=template&id=1cbea244&scoped=true&"
import script from "./PricingRuleGroup.vue?vue&type=script&lang=js&"
export * from "./PricingRuleGroup.vue?vue&type=script&lang=js&"
import style0 from "./PricingRuleGroup.vue?vue&type=style&index=0&id=1cbea244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbea244",
  null
  
)

export default component.exports